import { css } from 'styled-components';
import { rem } from 'polished';

var listStyles = function listStyles() {
  return css(["margin-bottom:", ";padding-left:", ";"], rem(16), rem(16));
};

export default listStyles;